import { HcaptchaRunner } from './hcaptcha'
import _ from 'lodash'

let _runner = null

export function getHcaptchaRunner (config) {
  if (_runner === null) {
    _runner = new HcaptchaRunner(config)
  }
  return _runner
}

export function apiResponseTransformer (resp) {
  if (!resp.data) {
    resp.data = {}
  }

  if (resp.status === 412) {
    const message = _.get(resp, 'data.error.message', ':')
    resp.data.ip = (message.split(':')[1] || '').trim()
    resp.data.isRecaptchaOk = false
  } else {
    resp.data.isRecaptchaOk = true
  }
}
